module.exports = __webpack_public_path__ + "static/media/podcast.42e2a1f8.svg";